import { css } from '@emotion/css';
import { verticalStyle } from 'Shared/backend/widgets/Widget';
import { WidgetInfo } from 'Shared/backend/widgets/WidgetInfo';
import { Checkbox, Integer } from 'Shared/forms/Inputs'
import { LabelOnLeftWrap } from 'Shared/forms/Wrap'
import { Show } from 'solid-js'

const verticalWithTopMarginStyle = () => css(verticalStyle(),{
	marginTop: '1em'
});

export const indentPaneStyle = () => css(verticalStyle(), {
	paddingLeft: '1em'
});

export function PosterList(props)
{
	return (
		<div class={verticalWithTopMarginStyle()}>
			<WidgetInfo {...props} />

			<LabelOnLeftWrap label='Flip to horizontal scrolling list if events exceed:'>
				<Integer {...props} field='carouselToScroll'/>
			</LabelOnLeftWrap>

			<Show when={props.layout?.includes('carousel')}>
				<LabelOnLeftWrap label='Make carousel extra wide on big screens'
					notes='Displays more posters in a row but might not look as neat because it will be wider than other sections'
				>
					<Checkbox {...props} field='noSectionWidth' />
				</LabelOnLeftWrap>
			</Show>
		</div>
	);
}

